import React, { useMemo, useState } from 'react';
import { Bubble, Select, ConfigProvider, Icon } from 'tea-component';
import DeleteSetting from './DeleteSetting';
import SvgIcon from '@/pages/home/components/SvgIcon';
import en_US from 'tea-component/es/i18n/locale/en_US';
import { isEmpty } from 'lodash';

const FilterSelect = (props: any) => {
  const {
    filterSaveList,
    selectedValue,
    filterSaveChange,
    setEditFilter,
    setFilterModalInfo,
    deleteFilterSaveFetch,
  } = props;

  const [settingShow, setSettingShow] = useState(false);
  const [deletedFilter, setDeletedFilter] = useState({});

  const renderSaveListData = useMemo(
    () =>
      filterSaveList?.map((item: any) => ({
        id: item?.id,
        value: item?.name,
        text: (
          <div className="select-filter-tab">
            <Bubble dark content={item?.name}>
              <span className="select-filter-tab-text">{item?.name || ''}</span>
            </Bubble>
            <div className="select-filter-tab-icon-list">
              <Bubble dark content={'Edit'}>
                <i
                  className="select-filter-tab-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    setEditFilter(item);
                    setFilterModalInfo({
                      filterModalType: 'edit',
                      filterModalVisible: true,
                    });
                  }}
                >
                  <Icon type={'pencil'} />
                </i>
              </Bubble>
              <Bubble dark content={'Delete'}>
                <i
                  className="select-filter-tab-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    setDeletedFilter(item);
                    setSettingShow(true);
                  }}
                >
                  <SvgIcon type="clear-icon" />
                </i>
              </Bubble>
            </div>
          </div>
        ),
        context: item?.name || '',
      })) || [],
    [filterSaveList],
  );

  const selectedValueCur: any = useMemo(() => {
    let pointValue = {};
    if (!isEmpty(selectedValue)) {
      pointValue = filterSaveList?.find((item: any) => item.id === selectedValue?.id) || {};
    }
    return pointValue;
  }, [filterSaveList, selectedValue]);

  return (
    <span id="select-save-filter">
      <ConfigProvider locale={en_US}>
        <Select
          className={`select-filter`}
          appearance="button"
          searchPlaceholder={'Search Filter Setting '}
          boxClassName={`select-filter-box dbg-select-filter-box ${
            renderSaveListData?.length === 0 ? 'dbg-select-filter-no-data' : ''
          }`}
          overlayClassName="dbg-select-save-filter-overlay"
          searchable={true}
          listWidth={268}
          listHeight={220}
          options={renderSaveListData}
          value={selectedValueCur?.name}
          onChange={(value: any) => {
            // 当前需求，名称不能重复，所以用value直接获取选中项，如果后面名称可以重复则用id判断（context里拿）
            const selectObj =
              filterSaveList?.filter((item: any) => item?.name === value)?.[0] || {};
            filterSaveChange(selectObj);
          }}
          footer={
            <div className="dbg-searchbox-label">
              {/* <Bubble dark content={'Up to 10 settings can be saved'} placement="top-start"> */}
              {'Up to 10 settings can be saved'}
              {/* </Bubble> */}
            </div>
          }
          button={
            <div className="select-filter-flex" id="filter-scheme">
              <SvgIcon type="funnel" className="select-filter-icon" />
              {!selectedValueCur?.name ? (
                <span className="select-filter-text">{'My Filter'}</span>
              ) : (
                <span className="action-text">
                  {
                    renderSaveListData?.filter((e: any) => e.value === selectedValueCur?.name)?.[0]
                      ?.context
                  }
                </span>
              )}
            </div>
          }
        />
      </ConfigProvider>
      <DeleteSetting
        visible={settingShow}
        deletedFilter={deletedFilter}
        deleteFilterSaveFetch={deleteFilterSaveFetch}
        close={() => {
          setSettingShow(false);
        }}
      />
    </span>
  );
};

export default FilterSelect;
